import reducer from './reducer';

export const { setPageNumber } = reducer.actions;
